import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class CatastrofeService {
    constructor(private http: HttpClient) { }

    traePostulantes(rut: any) {
        return this.http.get(`${environment.urlBase}/afiliados/rut/${rut}`,
            { headers: this.armaCabecera() }).toPromise();
    }


    buscarHijo(rut: any) {
        return this.http.get(`${environment.urlApiSubsidio}/nacimiento/registroCivil/${rut}`,
            { headers: this.armaCabecera() }).toPromise();
    }

    ingresarCatastrofe(catastrofe: any, fechaCatastrofe: any, idAfiliado: any, idEjecutivo:any) {

        return this.http.post(`${environment.urlApiSubsidio}/solicitud/catastrofe`,
            {
                idUsuario: idAfiliado,
                idProducto: 10,
                idEjecutivoAsignado:idEjecutivo,
                archivoAdjunto: catastrofe.archivo,
                catastrofe: {
                    idCiudad: catastrofe.comuna,
                    idRegion: catastrofe.region,
                    fechaCatastrofe: fechaCatastrofe,
                    tipoCatastrofe: catastrofe.tipoCatastrofe,
                    domicilioCatastrofe: catastrofe.domicilioCatastrofe,
                    otraCatastrofe: catastrofe.otroTipoCatastrofe
                }

            },
            { headers: this.armaCabecera() }).toPromise();
    }

    traeTipoCatastrofe() {

        return this.http.get(`${environment.urlApiSubsidio}/getTipoCatastrofe`,
            { headers: this.armaCabecera() }).toPromise();
    }

    traeTipoVivienda() {
        return this.http.get(`${environment.urlApiSubsidio}/getTipoVivienda`,
            { headers: this.armaCabecera() }).toPromise();
    }

    
    traeMagnitudDanno() { 
        return this.http.get(`${environment.urlApiSubsidio}/getMagnitudDanno`,
            { headers: this.armaCabecera() }).toPromise();
    }

    editarCatastrofe(data: any, fechaCatastrofe: any, idUsuario: any ,idUsuarioSesion: any) {
        return this.http.put(`${environment.urlApiSubsidio}/solicitud/catastrofe`,
            {
                idUsuario: idUsuario,
                id: data.idPostulacion,
                idProducto: 10,
                archivoAdjunto: data.archivo,
                catastrofe: {
                    idCiudad: data.ciudad,
                    idRegion: data.region,
                    fechaCatastrofe: fechaCatastrofe,
                    tipoCatastrofe: data.tipoCatastrofe,
                    domicilioCatastrofe: data.domicilioCatastrofe,
                    otraCatastrofe: data.otroTipoCatastrofe,
                    caracteristicasVivienda: data.caracteristicasVivienda,
                    tipoVivienda: data.tipoVivienda,
                    visitaDomiciliaria: data.visitaDomiciliaria,
                    magnitudDanno: data.magnitudDanno,
                    observacionCatastrofe: data.observacionCatastrofe
                }
            },
            { headers: this.armaCabecera() }).toPromise();
    }


    armaCabecera() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}